<template>
  <div class="w-100 h-100" style="position: relative">
    <img class="w-100 h-100" style="object-fit: scale-down;" v-if="this.$store.state.designPreview.isShowUploadImage && (!isUploadDesign && !isUploadCutline)" :src="getUploadImage">
    <Preview2D v-if="(isUploadDesign || isUploadCutline) && !this.$store.state.designPreview.is3DPreviewMode" />
    <Preview3D v-if="(isUploadDesign || isUploadCutline) && this.$store.state.designPreview.is3DPreviewMode" />
  </div>
</template>

<script>
import Preview2D from "@/components/acyrpro/preview/Preview2D.vue";
import Preview3D from "@/components/acyrpro/preview/Preview3D.vue";
import { ReplacePngColor } from "@/js/CommonFunc.js";
import { PreviewColorList, ProductId } from "@/js/Const.js";

export default {
  name: "DesignPreview",
  props: {
  },
  components: {
    Preview2D,
    Preview3D,
  },
  data() {
    return {
    };
  },
  computed: {
    isUploadDesign() {
      return this.$store.state.designPreview.designImageURL != null;
    },
    isUploadCutline() {
      return this.$store.state.designPreview.originalCutlineImageURL != null;
    },
    getUploadImage(){
      switch(this.$store.state.designPreview.selectProductId){
          case ProductId.S:
          case ProductId.S_SVG:
          case ProductId.S_SHARE:
          case ProductId.S_SVG_SAMPLE:
          case ProductId.S_SHARE_SAMPLE:
            return require("@/assets/acrypro/upload_info_s.svg");
          case ProductId.M:
          case ProductId.M_SVG:
          case ProductId.M_SHARE:
          case ProductId.M_SVG_SAMPLE:
          case ProductId.M_SHARE_SAMPLE:
            return require("@/assets/acrypro/upload_info_m.svg");
          case ProductId.L:
          case ProductId.L_SVG:
          case ProductId.L_SHARE:
          case ProductId.L_SVG_SAMPLE:
          case ProductId.L_SHARE_SAMPLE:
            return require("@/assets/acrypro/upload_info_l.svg");
          default:
            return require("@/assets/acrypro/upload_info_s.svg");
      }
    }
  },
  watch: {
    "$store.state.designPreview.selectCutlineColor": async function () {
      const Color = PreviewColorList[this.$store.state.designPreview.selectCutlineColor];
      const fileUrl = await ReplacePngColor(this.$store.state.designPreview.originalCutlineImageURL, Color);
      this.$store.commit("setDesignPreviewData", { key: 'originalCutlineImageURL', value: fileUrl});

      const fileUrl2 = await ReplacePngColor(this.$store.state.designPreview.cutlineContourImageURL, Color);
      this.$store.commit("setDesignPreviewData", { key: 'cutlineContourImageURL', value: fileUrl2});
    },
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.preview-border{
  border: 2px solid $primary-main-color;
  background-color: $background-white-color;
}

.preview-title{
  color: $text-white-color;
  background-color: $primary-main-color;
}
.radio-btn{
  height: 25px;
  width: 25px;
  accent-color: #8593bc;
}
</style>
